function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.386,9.174l11.768,11.768c-.38.037-.765.057-1.154.057-.091,0-.174-.012-.264-.014L.819,10.068c.161-.274.354-.578.567-.894Zm1.221-1.607l12.895,12.895c.359-.114.713-.243,1.062-.392L3.303,6.809c-.248.252-.478.506-.696.758ZM.138,12.636s.727,1.441,1.376,2.383l4.026,4.026c.826.545,1.746,1.022,2.778,1.364L.011,12.102c.012.183.049.364.127.535Zm19.1,5.865l4.39,4.39-.707.707L.373,1.05l.707-.707,4.551,4.551c1.935-1.256,4.076-1.893,6.37-1.893,7.846,0,11.506,7.506,11.898,8.362.185.406.185.87,0,1.274-.393.858-1.848,3.71-4.661,5.865Zm-4.065-4.065c1.205-1.567,1.09-3.83-.344-5.265s-3.698-1.549-5.265-.344l5.609,5.609Zm7.814-2.215c.065-.142.065-.303,0-.444-.364-.795-3.766-7.777-10.988-7.777-2.025,0-3.922.544-5.646,1.618l2.497,2.498c1.962-1.592,4.859-1.476,6.684.349s1.942,4.722.349,6.684l2.639,2.639c2.776-2.084,4.198-4.987,4.463-5.566Z",
    style: {
      stroke: "#71b7f0",
      fill: "#71b7f0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowVision);
export default __webpack_public_path__ + "static/media/low-vision.a332a7c07555dd41ce2eff14261d7370.svg";
export { ForwardRef as ReactComponent };